/* Custom Build — cart grouping helpers
   Removes every line belonging to one build in a single request.
   Loaded by snippets/cart-form-page.liquid. */
(function () {
  'use strict';

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root : '/';
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cb-remove]');
    if (!link) return;
    e.preventDefault();

    var keys = (link.getAttribute('data-cb-remove-keys') || '').split('|').filter(Boolean);
    if (!keys.length) { window.location.reload(); return; }

    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });

    link.style.pointerEvents = 'none';
    link.textContent = 'Removing…';

    fetch(routeRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function (err) {
        console.error('[custom-build-cart]', err);
        link.style.pointerEvents = '';
        link.textContent = 'Remove';
      });
  });
})();
